<template>
  <div class="video-content">
    <slot></slot>
    <div class="overlay"></div>
  </div>
</template>

<script>
export default {
  name: "video-content",
};
</script>

<style lang="scss" scoped>
@import "~@/scss/styles.scss";

.video-content {
  position: relative;
  //overflow: hidden; // this prevents the overlay from being visible and sized incorrectly before the video loads
  @include breakpoint(xs) {
    width: 100%;
    min-height: 568px;

    // margin-left: -70px;
    display: flex;
    justify-content: center;

    span {
      display: block;
      width: 100%;

      &::v-deep img,
      &::v-deep video {
        width: 100%;
        height: auto;
      }
    }
  }
  @include breakpoint(md) {
    width: 100%;
    margin-left: -101px;
    overflow: none;
    position: none;
  }

  @include breakpoint(sm) {
    width: 100%;
    margin-left: -101px;
    overflow: none;
    position: none;
  }
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow: inset 0 0 20px 15px #dadada;
  @include breakpoint(md) {
    width: 0;
  }
  @include breakpoint(sm) {
    width: 0;
  }
  @include breakpoint(xs) {
    width: 0;
  }
}
</style>
